import React from 'react';
import clsx from 'clsx';
import { POST_LANGUAGE_OPTIONS } from '../../types/post';
import { useLanguage } from '../../i18n/useLanguage';

type AppLang = (typeof POST_LANGUAGE_OPTIONS)[number]['value'];

export const LanguageSelector: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  const optionLabel = (value: string) => (value === 'de' ? 'DE' : 'EN');

  return (
    <div
      className="language-selector language-selector--segmented"
      role="group"
      aria-label={t('common.language')}
    >
      {POST_LANGUAGE_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={clsx(
            'language-selector-option',
            language === option.value && 'language-selector-option--active',
          )}
          onClick={() => setLanguage(option.value as AppLang)}
          aria-pressed={language === option.value}
        >
          {optionLabel(option.value)}
        </button>
      ))}
    </div>
  );
};
